import React from "react";

interface Props {
  activeColor: string;
}
const ClientsIcon = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11Z"
          fill={props.activeColor}
          stroke={props.activeColor}
        />
        <path
          d="M8 11C9.66 11 11 9.66 11 8C11 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11Z"
          fill={props.activeColor}
          stroke={props.activeColor}
        />
        <path
          d="M8 13C5.33 13 0 14.34 0 17V19H16V17C16 14.34 10.67 13 8 13Z"
          fill={props.activeColor}
          stroke={props.activeColor}
        />
        <path
          d="M16 13C15.67 13 15.29 13.02 14.88 13.05C16.19 13.94 17 15.26 17 17V19H24V17C24 14.34 18.67 13 16 13Z"
          fill={props.activeColor}
          stroke={props.activeColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_74">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClientsIcon;
